/** @format */

import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NsWISConfigurations } from "../../../models/configurations.model";
import { CONSTANTS_QUICK_ACTIONS, CONSTANTS_QUICK_ACTIONS_PARKING } from "../../../constants/quick-actions.constants";
import { HomeDataService } from "../../../services/home-data.service";
import { MenuDirective } from "../../../modules/menu/menu.directive";
@Component({
  selector: "mis-employee-web-exp-quick-actions",
  templateUrl: "./quick-actions.component.html",
  styleUrls: ["./quick-actions.component.scss"]
})
export class QuickActionsComponent implements OnInit {
  quickActions = [];
  @Input() config: NsWISConfigurations.IConfigurations;
  @Input() menuOrigin: MenuDirective;
  @Output() quickAction = new EventEmitter<string>(true);
  constructor(private homeDataSvc: HomeDataService) {}

  ngOnInit(): void {
    const bookingConfigs = this.config?.BUSettings?.features.find(x => x.id === "booking");
    const configMap = { ...bookingConfigs, ...this.config.flattenedSettings };
    const actions =
      !!this.config.flattenedSettings?.onlyParkingBookingEnabled && this.config.flattenedSettings?.onlyParkingBookingEnabled
        ? CONSTANTS_QUICK_ACTIONS_PARKING
        : CONSTANTS_QUICK_ACTIONS;
    this.quickActions = actions.filter(act => act.reqConfigs.every(key => configMap[key]));
  }

  quickActionEvent(id: string) {
    this.homeDataSvc.quickActionEvent(id, res => {
      if (res) {
        this.quickAction.emit(id);
      }
      this.menuOrigin?.close();
    });
  }
}
